import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Row, Col } from 'react-flexbox-grid';

import _get from 'lodash/get';

import { entityType } from 'types';

import FormGroupAutoCompleteField from 'components/AutoCompleteMenuWrapper';

import '../../style.scss';

const Shift = ({
  field,
  fieldPayload,
  matchingPatterns,
  matchingPatternsWithoutAnyAndW,
  isArchived,
  isEntityArchived,
}) => {
  const from = _get(
    fieldPayload,
    'shift_action.matching_pattern_element_from.order',
    0,
  );

  const matchingPatternsTo = matchingPatterns.slice(from);

  return (
    <Row>
      <Col xs>
        <Row>
          <Col xs={2} styleName="field-group-type">
            Change Span
          </Col>

          <Col xs={4} data-test={`${field}-shift-mpe`}>
            <Field
              itemWithIndex
              name={`${field}.shift_action.matching_pattern_element`}
              component={FormGroupAutoCompleteField}
              placeholder="Select Entity"
              items={matchingPatternsWithoutAnyAndW}
              isDisabled={isArchived}
              isArchived={isEntityArchived}
            />
          </Col>
        </Row>

        <Row>
          <Col xsOffset={1} xs={2}>
            <div styleName="property-name">span</div>
          </Col>

          <Col xs={3} data-test={`${field}-shift-mpe-from`}>
            <Field
              itemWithIndex
              name={`${field}.shift_action.matching_pattern_element_from`}
              component={FormGroupAutoCompleteField}
              placeholder="From"
              items={matchingPatterns}
              isDisabled={isArchived || isEntityArchived}
            />
          </Col>

          <Col xs={3} data-test={`${field}-shift-mpe-to`}>
            <Field
              name={`${field}.shift_action.matching_pattern_element_to`}
              component={FormGroupAutoCompleteField}
              placeholder="To"
              itemWithIndex
              itemIndexOffset={from}
              items={matchingPatternsTo}
              isDisabled={isArchived || isEntityArchived}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

Shift.propTypes = {
  field: PropTypes.string.isRequired,
  fieldPayload: PropTypes.shape({
    shift_action: PropTypes.shape({
      matching_pattern_element_from: PropTypes.shape({
        index: PropTypes.number,
      }),
    }),
  }),
  isArchived: PropTypes.bool,
  isEntityArchived: PropTypes.bool,
  matchingPatterns: PropTypes.arrayOf(entityType),
  matchingPatternsWithoutAnyAndW: PropTypes.arrayOf(entityType),
};

export default Shift;
